module.exports = __webpack_public_path__ + "static/media/mission-white.e63fae08.svg";